// Import: Middleware Action & Custom Types
import { CHANGE_SIM_CLEAN, CHANGE_SIM_CLEAN_ERROR } from "_models/redux/types";

// Action function
export const cleanChangeSim = (params) => async (dispatch) => {
    // Endpoint: Try & Catch

    try {
        dispatch({
            type: CHANGE_SIM_CLEAN,
            payload: [],
        });
    } catch (e) {
        dispatch({
            type: CHANGE_SIM_CLEAN_ERROR,
            payload: [],
        });
    }
};
